import {Box, Img, Stack} from '@chakra-ui/react';
import * as React from 'react';
import GridView from './GridView';
import HeroTeamLogoSvg from '../../../../assets/images/hero-teams.svg';
import Container from "../../../../components/Container";

const TeamHero = ({data}) => {
    return (
        <>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'} as="section" mx={'auto'}>
                <Container>
                    <Stack
                        direction={{base: 'column-reverse', md: 'column-reverse', lg: 'row'}}
                        spacing={['10px', '10px', '10px', '10px', '149px']}
                        align={{lg: 'center'}}
                        justify="space-between"
                        px={'20px'}
                    >
                        <Box h={'100%'}>
                            <Box
                                position={'relative'}
                                minW={'166px'}
                                width={'20.5vmax'}
                                minH={'86px'}
                                height={'35.1vmin'}
                                mb={['45px', '45px', 0]}
                            >
                                <Img
                                    draggable={'false'}
                                    src={HeroTeamLogoSvg}
                                    alt={'partnerWithUs'}
                                    position={'absolute'}
                                    inset={'0'}
                                />
                            </Box>
                        </Box>
                        <Box h={'100%'} flex="1" pos="relative">
                            <GridView data={data}/>
                        </Box>
                    </Stack>
                </Container>
            </Box>
        </>
    );
};

export default TeamHero;
